import React, { ReactNode } from 'react'
import Link from 'next/link'
import { Separator } from 'components/atoms'
import { BrandCard } from 'components/molecules'
import { FormRegistrazione, Page } from 'components/organisms'
import styles from './RegistrazioneTemplate.module.sass'
import { WContainer } from '@components/atoms'

const RegistrazioneTemplate = ({
  pagina,
  iframe,
  from,
  children,
  preferenzeOpen,
}: {
  pagina?: any
  iframe?: boolean
  from?: string
  children?: ReactNode
  preferenzeOpen?: boolean
}) => (
  <Page pagina={pagina} item={{}} contentClassName={styles.registrazioneTemplate} iframe={iframe}>
    <WContainer variant="sm">
      <div className={styles.container}>
        {(!!pagina.titolo || !!pagina.descrizione) && (
          <div className={styles.head}>
            {!!pagina.titolo && <h1 className={styles.title}>{pagina.titolo}</h1>}
            {!!pagina.descrizione && (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: pagina.descrizione }}
              />
            )}
          </div>
        )}
        <FormRegistrazione iframe={iframe} from={from} preferenzeOpenDefault={preferenzeOpen} />
        <div className={styles.bottom}>
          <p className={styles.loginLink}>
            Hai già un account?{' '}
            <Link legacyBehavior href="/login">
              <a>Login</a>
            </Link>
          </p>
        </div>

        <div className={styles.separatorContainer}>
          <Separator className={styles.separator} />
        </div>

        <BrandCard showTitle={false} classNameContent={styles.brandCardContent} />
      </div>
    </WContainer>
  </Page>
)

export default RegistrazioneTemplate
